/*
Dilip 02/02/2023 3031450488 addded download functionality for data manager Execution History
*/
import React from 'react';
import DmExecution from '../index';
function DmExportExecution() {
  return (
    <DmExecution type={'Export'} />
  );
}

export default DmExportExecution;
